import React, { useState, useContext } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { DesignContext } from "contexts/DesignContext";
import { themeDefault } from "designer/component/system/themes/containerTheme";
import {
  getDesignerDragItemProps,
  getDesignerDropProps,
} from "designer/component/system/layout/control/customDragDrop";

const DropModal = (props) => {
  let { uischema, children, path } = props;
  const designContext = useContext(DesignContext);
  const { editUi, saveUi, closeUi, deleteUi, editorDropId } = designContext;

  const [isDropDisabled, setIsDropDisabled] = useState(true);
  const [isHidden, setIsHidden] = useState(false);
  const dragItemProps = getDesignerDragItemProps({ designContext, uischema });
  const dropProps = getDesignerDropProps(uischema.key);

  return (
    <Col
      className={`position-relative p-0 w-100`}
      sm={uischema.layoutWidth}
      hidden={!uischema.isShowUi}
    >
      <div {...dragItemProps}>
        <div
          style={{ border: "1px dashed" }}
          className={`p-1 m-1 rounded ${
            isDropDisabled ? "border-secondary" : "border-warning"
          }`}
        >
          <Row className="w-100 mx-0 mb-1 d-flex justify-content-end">
            <Button
              variant={"light"}
              className="btn-icon py-0 px-1 ml-1 mr-0"
              onClick={() => {
                if (isHidden) {
                  setIsHidden(false);
                } else {
                  setIsHidden(true);
                }
              }}
            >
              <i className={`feather icon-${isHidden ? "eye" : "eye-off"}`}></i>
            </Button>
            <Button
              variant={"secondary"}
              className="btn-icon py-0 px-1 ml-1 mr-0"
              onClick={() => closeUi(uischema.key)}
            >
              <i className="feather icon-minus"></i>
            </Button>
            <Button
              variant={isDropDisabled ? "warning" : "success"}
              className="btn-icon py-0 px-1 ml-1 mr-0"
              onClick={() => {
                if (isDropDisabled) {
                  editUi(uischema);
                  setIsDropDisabled(false);
                } else {
                  saveUi();
                  setIsDropDisabled(true);
                }
              }}
              hidden={!uischema.isCanEdit}
            >
              <i
                className={`feather icon-${isDropDisabled ? "edit" : "save"}`}
              ></i>
            </Button>
            <Button
              variant={"danger"}
              className="btn-icon py-0 px-1 ml-1 mr-0"
              onClick={() => {
                deleteUi(uischema, path, uischema.key);
              }}
              hidden={!uischema.isCanDelete}
            >
              <i className="feather icon-trash"></i>
            </Button>
          </Row>
          <div hidden={isHidden}>
            <div className="w-100" {...dropProps}>
              <MuiThemeProvider theme={themeDefault}>
                {children}
              </MuiThemeProvider>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default DropModal;
